import axios, { type AxiosInstance } from "axios";

// import.meta.env.DEV is Vite's own build-time flag (true only for `nuxt
// dev`/`vite dev`, always false for a real build) — required alongside
// VITE_APP_ENV so a stray APP_ENV=local baked into a staging/production
// build can't silently switch this to the local-only relative path (see
// nuxt.config.ts's isLocalDevBuild for the same fix applied to the main
// axios client, after a homolog build with a leaked APP_ENV=local produced
// doubled "/api-main/api-main/..." URLs on every request).
//@ts-ignore
const httpServiceMain: AxiosInstance = axios.create({
  baseURL:
    (import.meta.env.DEV && import.meta.env.VITE_APP_ENV === "local") ||
    import.meta.env.VITE_BASE_URL_NETWORK?.includes("localhost")
      ? "/api-main/api/v1"
      : import.meta.env.VITE_BASE_URL_NETWORK,
  // baseURL: import.meta.env.VITE_APP_ENV === "local" ? 'http://localhost:8081/api/v1' : 'http://localhost:8081/api/v1',
  withCredentials: true,
  // Reference-data endpoints can legitimately take several seconds in local and
  // staging environments. A single slow lookup must not cancel company onboarding.
  timeout: 30000,
});

const SUPPORTED_LOCALES = ["en", "pt-BR", "de", "es", "ro", "ar-AE"];

httpServiceMain.interceptors.request.use((config) => {
  const pathSegment = typeof location === "undefined" ? "en" : location.pathname.split("/")[1] || "en";
  const lang = SUPPORTED_LOCALES.includes(pathSegment) ? pathSegment : "en";
  // config.withCredentials = true;
  config.params = {
    ...config.params,
    lang,
  };
  if (process.env.NODE_ENV === "development" && import.meta.env.VITE_BEARER_TOKEN) {
    config.headers.Authorization = `Bearer ${import.meta.env.VITE_BEARER_TOKEN}`;
    config.headers.set("X-Timezone", Intl.DateTimeFormat().resolvedOptions().timeZone);
  }
  return config;
});

export default httpServiceMain;
